import type { z } from 'zod';
import { getGrammarLessonV1RequestSchema } from '../getGrammarLessonV1';

const getGrammarLessonV2RequestSchemaDefinition = getGrammarLessonV1RequestSchema.extend({});

export const getGrammarLessonV2RequestSchema: typeof getGrammarLessonV2RequestSchemaDefinition =
  getGrammarLessonV2RequestSchemaDefinition;

export type IGetGrammarLessonV2Request = z.infer<typeof getGrammarLessonV2RequestSchema>;
